<template>
  <div id="daily-reports-add-form" :style="{ height: pageHeight + 'px' }">
    <Viewport v-model="pageHeight">
      <ElForm class="form ghost-button-styles" ref="addForm" :model="configForm" label-width="110px" :rules="formRules">
        <ElFormItem label="报表名称" prop="reportName">
          <el-input v-model="configForm.reportName" placeholder="字数1-200个字符"> </el-input>
        </ElFormItem>

        <ElFormItem label="报表模板">
          <el-radio-group v-model="configForm.reportTemplate" @input="$refs.addForm.resetFields()">
            <el-radio-button
              ghost
              v-for="radio in DailyReports.REPORTS_TEMPLATE_TYPES_LIST"
              :disabled="!!configForm.id"
              :key="radio.value"
              :label="radio.value"
            >
              {{ radio.name }}
            </el-radio-button>
          </el-radio-group>

          <div class="template-preview-images">
            <img v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.MARKET" src="/images/daily/u338.png" alt="" />
            <img v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.OPERATION" src="/images/daily/u237.png" alt="" />
            <img
              style="width: 55%"
              v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.NEW_OPERATION"
              src="/images/daily/u737.png"
              alt=""
            />
            <img
              v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.DISTRIBUTE"
              src="/images/daily/u426.png"
              alt=""
            />
            <img v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.EFFECTIVE" src="/images/daily/u123.png" alt="" />
            <img
              style="width: 160%"
              v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.CUSTOM1"
              src="/images/daily/u122.png"
              alt=""
            />
            <img
              style="width: 160%"
              v-show="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.JJKL"
              src="/images/daily/u133.png"
              alt=""
            />
          </div>
        </ElFormItem>

        <!-- 新运营报表的游戏选择 -->
        <template v-if="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.NEW_OPERATION">
          <ElFormItem
            v-for="(gameItem, idx) in configForm.marketGameList"
            :key="idx"
            :label="idx === 0 ? '市场游戏选择' : ''"
            :prop="`marketGameList.${idx}.name`"
            :rules="formRules.newMarketGame"
          >
            <div class="game-list">
              <div class="game-form">
                <MiddlewareGameRow
                  :game-item="configForm.marketGameList[idx]"
                  @change="$refs.addForm.validateField(`marketGameList.${idx}.name`)"
                >
                </MiddlewareGameRow>

                <el-input v-model="gameItem.name" placeholder="表格显示名称，必填"></el-input>
                <i class="close el-icon-error" v-if="marketGameListLen > 1" @click="removeGameItem('marketGameList', idx)"></i>
              </div>
            </div>
          </ElFormItem>

          <ElFormItem>
            <div class="game-list-bottom">
              <el-button type="text" @click="addGameRow('marketGameList')">+添加游戏</el-button>
              <span class="limit-tips">({{ marketGameListLen }}/50)</span>
            </div>
          </ElFormItem>

          <ElFormItem
            v-for="(gameItem, idx) in configForm.channelGameList"
            :key="`${idx}-`"
            :label="idx === 0 ? '渠道选择游戏' : ''"
            :prop="`channelGameList.${idx}.name`"
            :rules="formRules.newChannelGame"
          >
            <div class="game-list">
              <div class="game-form">
                <MiddlewareGameRow
                  :game-item="configForm.channelGameList[idx]"
                  @change="$refs.addForm.validateField(`channelGameList.${idx}.name`)"
                >
                </MiddlewareGameRow>

                <el-input v-model="gameItem.name" placeholder="表格显示名称，必填"></el-input>
                <i class="close el-icon-error" v-if="channelGameListLen > 1" @click="removeGameItem('channelGameList', idx)"></i>
              </div>
            </div>
          </ElFormItem>

          <ElFormItem>
            <div class="game-list-bottom">
              <el-button type="text" @click="addGameRow('channelGameList')">+添加游戏</el-button>
              <span class="limit-tips">({{ channelGameListLen }}/50)</span>
            </div>
          </ElFormItem>
        </template>

        <!-- 非新运营报表的游戏选择 -->
        <template v-else>
          <ElFormItem
            v-for="(gameItem, idx) in configForm.gameList"
            :key="idx + gameItem._time"
            :label="idx === 0 ? '选择游戏' : ''"
            :prop="`gameList.${idx}.name`"
            :rules="formRules.game"
          >
            <div class="game-list">
              <div class="game-form">
                <!--选择游戏组[投放、运营日报] -->
                <GroupedGameRow
                  v-if="marketAndOperationType || effectiveType || custom1Type || jjklType"
                  :game-item="configForm.gameList[idx]"
                  @change="$refs.addForm.validateField(`gameList.${idx}.name`)"
                >
                  <!-- 定制报表1不需要平台选择 -->
                  <span v-if="custom1Type || jjklType"></span>
                  <!-- 综合效果报表的平台多选 -->
                  <el-select
                    v-if="effectiveType"
                    v-model="configForm.gameList[idx].platforms"
                    @change="$refs.addForm.validateField(`gameList.${idx}.name`)"
                    multiple
                    collapse-tags
                    placeholder="请选择平台"
                    style="min-width: 120px"
                  >
                    <el-option v-for="item in DailyReports.GAME_PLATFORM_LIST" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- 计算起始日只有投放日报有 -->
                  <el-date-picker
                    slot="start-date"
                    v-if="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.MARKET"
                    v-model="gameItem.startDate"
                    placeholder="计算起始日"
                    style="min-width: 130px"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{ disabledDate: (time) => time.getTime() > Date.now() }"
                  >
                  </el-date-picker>
                </GroupedGameRow>

                <!-- 选择中间件游戏[产品发行日报] -->
                <!--选择游戏组[综合效果报表] -->
                <MiddlewareGameRow
                  v-if="configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.DISTRIBUTE"
                  :game-item="configForm.gameList[idx]"
                />

                <!-- 综合效果报表不显示标题 -->
                <template v-if="effectiveType || custom1Type || jjklType"></template>
                <!-- 其他的正常显示 -->
                <el-input v-else v-model="gameItem.name" placeholder="表格显示名称，必填"></el-input>

                <i class="close el-icon-error" v-if="gameListLen > 1" @click="removeGameItem('gameList', idx)"></i>
              </div>
            </div>
          </ElFormItem>

          <!-- 平台投放日报、产品发行日报显示添加游戏，综合效果报表不显示-->
          <ElFormItem
            v-if="
              [DailyReports.REPORTS_TEMPLATE_TYPES.DISTRIBUTE, DailyReports.REPORTS_TEMPLATE_TYPES.MARKET].includes(
                configForm.reportTemplate
              )
            "
          >
            <div class="game-list-bottom">
              <el-button type="text" @click="addDefaultGameRow">+添加游戏</el-button>
              <span class="limit-tips">({{ gameListLen }}/50)</span>
            </div>
          </ElFormItem>
        </template>

        <ElFormItem label="数据类型" v-show="effectiveType || custom1Type || jjklType">
          <el-radio-group v-model="configForm.dataType">
            <el-radio-button ghost :label="DailyReports.DATA_TYPE.BY_DAY">分日数据</el-radio-button>
            <el-radio-button ghost :label="DailyReports.DATA_TYPE.REAL_TIME" v-if="effectiveType">实时数据</el-radio-button>
          </el-radio-group>
        </ElFormItem>

        <ElFormItem label="数据时间" prop="dataTime" :rules="formRules.dataTime" v-show="effectiveType || custom1Type || jjklType">
          <div class="date-time" v-if="configForm.dataType === DailyReports.DATA_TYPE.BY_DAY">
            <div>
              <span>起始时间：</span>
              <el-date-picker
                v-if="effectiveType || custom1Type"
                v-model="configForm.startDate"
                :picker-options="{ disabledDate: (time) => time.getTime() > Date.now() }"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-date-picker
                v-if="jjklType"
                v-model="configForm.startDate"
                :picker-options="{ disabledDate: (time) => time.getTime() > Date.now() - 1000 * 60 * 60 * 24 }"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>

            <div>
              <span>&emsp;截止时间：</span>
              <el-date-picker
                v-if="effectiveType || custom1Type"
                class="end-date"
                v-model="configForm.endDate"
                :picker-options="{ disabledDate: (time) => time.getTime() > Date.now() }"
                value-format="yyyy-MM-dd"
                placeholder="至今"
                type="date"
              >
              </el-date-picker>

              <el-input v-if="jjklType" style="width: 220px" value="至昨天"></el-input>

              <el-tooltip effect="dark" :content="dataTimeRangeTips()" placement="top-start">
                <span>&ensp;<i class="el-icon-info"></i></span>
              </el-tooltip>
            </div>
          </div>

          <el-button v-else type="primary">今日实时数据</el-button>
        </ElFormItem>

        <ElFormItem class="send-timing" label="发送时间" prop="sendTime">
          <el-radio-group :value="1">
            <el-radio-button ghost :label="1">日报</el-radio-button>
          </el-radio-group>

          <div class="row">
            <label class="row-label">时间</label>
            <el-select v-model="configForm.sendTime.sendTimeHourMin" multiple collapse-tags>
              <el-option v-for="hour in hourRanges" :key="hour" :label="hour" :value="hour"> </el-option>
            </el-select>
          </div>

          <div class="row">
            <label class="row-label">周频率</label>
            <!-- 全选 -->
            <el-checkbox class="check-all" v-model="configForm.sendTime.weekCheckAll" @change="onWeekCheckAll">全选</el-checkbox>
            <!-- 星期一 ~ 星期天 -->
            <el-checkbox-group @change="onWeekDaycheck" v-model="configForm.sendTime.sendTimeDay">
              <el-checkbox :label="day.value" :key="day.value" v-for="day in DailyReports.NEW_TASK_WEEK_DAYS_LIST">
                {{ day.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </ElFormItem>

        <div v-show="custom1Type">
          <ElFormItem label="目标KPI开关">
            <el-switch disabled :value="true"></el-switch>
          </ElFormItem>

          <ElFormItem label="KPI设置">
            <p>来源于【运营投放KPI】-【买量】【安卓】【IOS】的【合格】的【月消耗】和【月活跃衰减】</p>
          </ElFormItem>

          <ElFormItem label="播报内容模板">
            <p>截止【昨日日期】买量用户营收进度：</p>
            <p>安卓完成XX.XX%（差/超XX万），iOS完成XX.XX%（差/超XX万），汇总完成20.99%，应完成率25.81%，未达标。</p>
            <p>买量安卓活跃衰减XX%，iOS活跃衰减XX%，汇总活跃DAU衰减3.08%，应完成率衰减3.87%，达标。</p>
          </ElFormItem>
        </div>

        <ElFormItem label="接收方式" prop="receiveType">
          <el-checkbox-group v-model="configForm.receiveType">
            <el-checkbox-button ghost v-for="item in DailyReports.RECIEVE_TYPES_LIST" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox-button>
          </el-checkbox-group>
        </ElFormItem>

        <ElFormItem v-if="showUsersInput" label="选择人员" prop="sendOpIds">
          <el-select v-model="configForm.sendOpIds" style="width: 100%" filterable multiple clearable>
            <el-option v-for="item in sysUsersData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem v-if="showWebhookInput" label="钉钉群消息" prop="webhook">
          <div class="webhooks">
            <div class="url-input" v-for="(group, idx) in dingWebhooks" :key="idx">
              <el-input v-model="group.url" placeholder="webhook链接"></el-input>
              <i class="close el-icon-error" v-if="webhookUrlLen > 1" @click="removeUrlItem(idx)"></i>
            </div>

            <div class="add-row">
              <el-button type="text" :disabled="webhookUrlLen >= 10" @click="addWebhookUrl">+添加链接</el-button>
              <p>({{ webhookUrlLen }}/10)</p>
              <p>消息通过钉钉群机器人发送，添加群机器人对应的Webhook链接</p>
            </div>
          </div>
        </ElFormItem>

        <ElFormItem>
          <el-button type="primary" @click="addSubmit" :loading="submit.loading">{{ submit.btnText }}</el-button>
          <el-button @click="$router.replace({ name: 'daily-list' })">取消</el-button>
        </ElFormItem>
      </ElForm>
    </Viewport>
  </div>
</template>
<script>
import moment from 'moment'
import DailyReports from './data/daily.class.js'
import { isArray } from '@/common/js/utils.js'
import { getMiddleGameList, getSysMember } from '@/api/common.model'
import { addOrUpdateDailyTask, getTaskDetailById } from '@/api/report.model'
import { getPtomGroupGames } from '@/api/material.model'

import GroupedGameRow from './components/grouped-game-row.vue'
import MiddlewareGameRow from './components/middleware-game-row.vue'

export default {
  name: 'daily-form',
  components: { GroupedGameRow, MiddlewareGameRow },
  provide: function () {
    return {
      parentForm: this
    }
  },

  data() {
    return {
      pageHeight: 500,
      submit: {
        loading: false,
        btnText: '确认'
      },
      hourRanges: DailyReports.makeHourRanges(),
      middlewareGameData: [], // 中间件游戏列表
      sysUsersData: [], // 系统全部人员列表
      appGroupsData: [], // 游戏组列表
      dingWebhooks: [{ url: '' }], // 钉钉群消息推送设置的webhook地址列表

      configForm: {
        gameList: [DailyReports.makeDefaultGameRow()], // 游戏列表
        marketGameList: [DailyReports.makeDefaultGameRow()], // 买量游戏列表
        channelGameList: [DailyReports.makeDefaultGameRow()], // 渠道游戏列表
        reportName: '',
        reportTemplate: 4,
        sendOpIds: [],
        receiveType: ['1'], // 接收类型
        dataType: 0,
        startDate: '',
        endDate: '',
        sendTime: {
          weekCheckAll: false, // 周全选
          sendTimeHourMin: ['09:00'],
          sendTimeDay: []
        }
      },
      formRules: {
        ...DailyReports.makeFormValidateRules.call(this)
      }
    }
  },
  computed: {
    DailyReports() {
      return DailyReports
    },
    labelNameByTemplate() {
      const { NEW_OPERATION } = DailyReports.REPORTS_TEMPLATE_TYPES
      return this.configForm.reportTemplate === NEW_OPERATION ? '买量选择游戏' : '选择游戏'
    },
    webhookUrlLen() {
      return this.dingWebhooks.length
    },
    gameListLen() {
      return this.configForm.gameList.length
    },
    marketGameListLen() {
      return this.configForm.marketGameList.length
    },
    channelGameListLen() {
      return this.configForm.channelGameList.length
    },
    // 平台投放日报、平台运营日报的平台类型 显示的平台下拉选择
    marketAndOperationType() {
      const { MARKET, OPERATION } = DailyReports.REPORTS_TEMPLATE_TYPES
      return [MARKET, OPERATION].includes(this.configForm.reportTemplate)
    },
    effectiveType() {
      return this.configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.EFFECTIVE
    },
    custom1Type() {
      return this.configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.CUSTOM1
    },
    jjklType() {
      return this.configForm.reportTemplate === DailyReports.REPORTS_TEMPLATE_TYPES.JJKL
    },
    // 个人钉钉、邮箱显示
    showUsersInput() {
      const types = this.configForm.receiveType
      const { RECIEVE_TYPES } = DailyReports
      return types.includes(RECIEVE_TYPES.DING) || types.includes(RECIEVE_TYPES.EMAIL)
    },
    // 钉钉群显示
    showWebhookInput() {
      const { RECIEVE_TYPES } = DailyReports
      return this.configForm.receiveType.includes(RECIEVE_TYPES.DING_GROUP)
    },
    taskId() {
      return this.$route.query.taskId
    }
  },
  created() {
    this.preloadData()

    // 编辑时获取任务详情
    if (this.taskId) {
      this.getTaskDetail()
    }
  },

  methods: {
    /**
     * @description: 根据任务id获取任务配置详情，用于编辑时回显
     */
    getTaskDetail() {
      getTaskDetailById({ taskId: this.taskId }).then((data) => {
        const sendTimeDay = data.sendTimeDay.split(',')
        const sendOpIds = data.sendOpIds.split(',').map((id) => Number(id))
        const { NEW_OPERATION, EFFECTIVE, CUSTOM1, JJKL } = DailyReports.REPORTS_TEMPLATE_TYPES

        let gameListObj = {
          // [gameList] : 平台、运营、产品日报回显的结构数组
          // [marketGameList] : 新运营买量选择游戏回显的结构数组
          // [channelGameList] : 新运营渠道选择游戏回显的结构数组
        }

        switch (data.reportTemplate) {
          case NEW_OPERATION:
            {
              // 新运营日报
              const { mlGameSelect, qdGameSelect } = JSON.parse(data.gameCondition) || {}
              gameListObj = {
                marketGameList: mlGameSelect || [],
                channelGameList: qdGameSelect || []
              }
            }
            break

          // 综合效果报表字段获取
          case CUSTOM1:
          case EFFECTIVE:
          case JJKL:
            {
              const gameCondition = JSON.parse(data.gameCondition)
              const { type, startDate, endDate } = gameCondition || {}
              gameListObj = this.getGameList({ ...data, gameCondition: JSON.stringify([gameCondition]) })
              gameListObj.dataType = type
              if (type === DailyReports.DATA_TYPE.BY_DAY) {
                gameListObj.startDate = startDate
                gameListObj.endDate = moment(endDate).isValid() ? endDate : ''
              }
            }

            break
          default: // 平台、运营、产品日报
            gameListObj = this.getGameList(data)
            break
        }

        this.configForm = {
          ...gameListObj,
          id: data.id,
          reportName: data.reportName,
          reportTemplate: data.reportTemplate,
          sendOpIds,
          receiveType: data.sendType.split(','),
          sendTime: {
            weekCheckAll: sendTimeDay.length === 7,
            sendTimeHourMin: data.sendTimeHourMin.split(','),
            sendTimeDay
          }
        }

        this.dingWebhooks = data.webhookConfig?.split(',')?.map((c) => ({ url: c })) || [{ url: '' }]
      })
    },

    getGameList(data) {
      const gameList = JSON.parse(data.gameCondition)
      const { MARKET, OPERATION } = DailyReports.REPORTS_TEMPLATE_TYPES

      return {
        gameList: gameList.map((g) => {
          const newRow = Object.assign({}, DailyReports.makeDefaultGameRow(), g)
          const { startDate } = g
          if (typeof startDate === 'string' && startDate.length && moment(startDate).isValid()) {
            // todo
          } else {
            newRow.startDate = ''
          }
          // 投放、运营日报[platforms]平台为单选，发行日报为多选
          if ([MARKET, OPERATION].includes(data.reportTemplate)) {
            return {
              ...newRow,
              platform: g.platforms.pop()
            }
          }
          return newRow
        })
      }
    },

    /**
     * @description: 构建提交的[投放、运营、发行日报]数据结构
     * @param {*} gameList
     * @return {*}
     */
    getGameConditions(gameList) {
      const { MARKET, OPERATION, DISTRIBUTE, EFFECTIVE, CUSTOM1, JJKL } = DailyReports.REPORTS_TEMPLATE_TYPES
      const { reportTemplate } = this.configForm
      return gameList.map((g) => {
        const { startDate, platform, gameGroupIds, middleGameIds, _time, ...finalParams } = g

        // 投放日报添加[startDate]起始投放日
        if (MARKET === reportTemplate) {
          finalParams.startDate = startDate
        }
        // 投放、运营日报[platforms]平台为单选，发行日报为默认多选，不需要显式地赋值
        // 投放、运营日报[gameGroupIds]添加游戏组id
        if ([MARKET, OPERATION].includes(reportTemplate)) {
          finalParams.platforms = [platform]
          finalParams.gameGroupIds = gameGroupIds
        }

        if ([EFFECTIVE, CUSTOM1, JJKL].includes(reportTemplate)) {
          finalParams.gameGroupIds = gameGroupIds

          const { dataType, startDate, endDate } = this.configForm
          finalParams.type = dataType
          // 分日类型加入时间范围
          if (dataType === DailyReports.DATA_TYPE.BY_DAY) {
            finalParams.startDate = startDate
            finalParams.endDate = endDate || (reportTemplate === JJKL ? '至昨天' : '至今')
          }
        }

        // 发行日报添加中间件游戏id
        if (DISTRIBUTE === reportTemplate) {
          finalParams.middleGameIds = middleGameIds
        }
        return finalParams
      })
    },

    /**
     * @description: 新增或编辑时提交逻辑
     */
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const { MARKET, OPERATION, DISTRIBUTE, NEW_OPERATION, EFFECTIVE, CUSTOM1, JJKL } = DailyReports.REPORTS_TEMPLATE_TYPES
          const { id, reportName, reportTemplate, sendTime, sendOpIds, receiveType, gameList, marketGameList, channelGameList } =
            this.configForm

          let gameCondition = []
          switch (reportTemplate) {
            case MARKET:
            case OPERATION:
            case DISTRIBUTE:
              gameCondition = this.getGameConditions(gameList)
              break
            case CUSTOM1:
            case JJKL:
            case EFFECTIVE:
              {
                const [condition] = this.getGameConditions(gameList) || []
                gameCondition = condition || {}
              }

              break
            case NEW_OPERATION:
              gameCondition = {
                mlGameSelect: marketGameList,
                qdGameSelect: channelGameList
              }
              break
            default:
              break
          }

          const params = {
            id, // 更新时必传
            reportName,
            reportTemplate,
            sendType: receiveType.join(','),
            sendOpIds: sendOpIds.join(','),
            sendTimeDay: sendTime.sendTimeDay.join(','),
            sendTimeHourMin: sendTime.sendTimeHourMin.join(','),
            gameCondition: JSON.stringify(gameCondition)
          }

          if (receiveType.includes(DailyReports.RECIEVE_TYPES.DING_GROUP)) {
            params.webhookConfig = this.dingWebhooks.map((d) => d.url).join(',')
          }

          this.submit.loading = true
          addOrUpdateDailyTask(params).then((data) => {
            if (data) {
              this.submit.btnText = '提交成功，2秒后跳转任务列表'
              setTimeout(() => {
                this.$router.replace({ name: 'daily-list' })
              }, 2000)
            } else {
              this.submit.loading = false
            }
          })
        }
      })
    },
    dataTimeRangeTips() {
      const text = '截止时间默认至今，每天发送都会自动随着时间做更新，时间更新到昨天；'
      return this.jjklType ? text : text.concat('时间跨度最大90天。')
    },

    onWeekDaycheck(v) {
      this.configForm.sendTime.weekCheckAll = v.length === 7
    },
    /**
     * @description: 发送时间周频率全选
     */
    onWeekCheckAll(isCheck) {
      const days = isCheck ? DailyReports.NEW_TASK_WEEK_DAYS_VALUE : []
      this.configForm.sendTime.sendTimeDay = days
    },
    removeGameItem(prop, idx) {
      this.configForm[prop].splice(idx, 1)
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },
    /**
     * @description: 新增游戏
     */
    addDefaultGameRow() {
      if (this.configForm.gameList >= 50) return
      const row = DailyReports.makeDefaultGameRow()
      this.configForm.gameList.push(row)
    },
    /**
     * @description: 新增买量、渠道游戏
     * @return {*}
     */
    addGameRow(prop) {
      const formGameRow = this.configForm[prop]
      if (!formGameRow) {
        console.log('formGameRow prop output: ', prop)
        return
      }
      if (formGameRow >= 50) return
      const row = DailyReports.makeDefaultGameRow()
      this.configForm[prop].push(row)
    },
    /**
     * @description: 新增webhook链接
     */
    addWebhookUrl() {
      if (this.webhookUrlLen >= 10) return
      this.dingWebhooks.push({ url: '' })
    },
    /**
     * @description: 删除一条hook url
     * @param {*} idx
     */
    removeUrlItem(idx) {
      this.dingWebhooks.splice(idx, 1)
    },
    preloadData() {
      Promise.all([getMiddleGameList(), getSysMember(), getPtomGroupGames()]).then((data) => {
        const [gameData, sysUsers, appGroups] = data
        if (isArray(gameData)) {
          this.middlewareGameData = gameData
        }
        if (isArray(sysUsers)) {
          this.sysUsersData = sysUsers
        }
        if (isArray(appGroups)) {
          this.appGroupsData = appGroups
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin close {
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
}
#daily-reports-add-form {
  overflow: auto;

  ::v-deep .form {
    width: 1024px;
    margin: 0 auto;
    margin-top: 20px;
    overflow: hidden;
    .template-preview-images {
      margin-top: 10px;
      img {
        width: 100%;
      }
    }
    .limit-tips {
      margin-left: 20px;
      font-size: 12px;
    }

    .game-list {
      .game-form {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
          margin-right: 10px;
        }
        .close {
          @include close;
        }
      }
    }
    .game-list-bottom {
      display: flex;
      align-items: center;
      p {
        font-size: 12px;
        margin-left: 10px;
      }
    }
    .send-timing {
      .row {
        margin-top: 10px;
        display: flex;
        .row-label {
          width: 60px;
        }
        .check-all {
          margin-right: 30px;
        }
      }
    }
    .end-date {
      input {
        &::placeholder {
          color: #606266;
        }
      }
    }
    .date-time {
      display: flex;
    }

    .webhooks {
      .add-row {
        display: flex;
        p {
          margin-left: 10px;
          font-size: 12px;
          color: #999;
        }
      }
      .url-input {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .close {
          @include close;
        }
      }
    }
  }
}
</style>
